import { render, staticRenderFns } from "./downloadBox.vue?vue&type=template&id=14ef9c53&scoped=true&"
import script from "./downloadBox.vue?vue&type=script&lang=js&"
export * from "./downloadBox.vue?vue&type=script&lang=js&"
import style0 from "./downloadBox.vue?vue&type=style&index=0&id=14ef9c53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ef9c53",
  null
  
)

export default component.exports